import {mainQuery} from '@github-ui/react-core/future/main-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {BaseComparisonInfoRoutePayload, FindingsRoutePayload} from './route-payload-types'
import {pageDataQuery} from './page-data-query'
import {FindingsRoutePath} from './route-paths'

export const pullRequestsFindingsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsFindingsRoute', {
  path: FindingsRoutePath,
  queries: [
    mainQuery<FindingsRoutePayload>(),
    pageDataQuery<BaseComparisonInfoRoutePayload, 'base_comparison_info'>('base_comparison_info'),
  ],
})
